import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import DownloadView from 'src/views/Download';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default DownloadView;